// Step 1: Import React
import * as React from "react";
import Layout from "../components/layout";
import {
  Accordion,
  AccordionItem,
  AccordionPanel,
} from "../components/accordion/accordion";
import { Colors, Illustrations, Learning, DevTools, SandBox, Design } from "../utils";

const ResourcePage = () => {
  return (
    <Layout pageTitle="Ressources">
      <Accordion>
        <AccordionItem
          toggle="panel-1"
          className="bg-indigo-100 text-text-primary rounded-lg text-xl font-medium"
        >
          Ressources graphiques
        </AccordionItem>
        <AccordionPanel id="panel-1">
          <h3 className="text-blue-700 ml-3">Colors</h3>
          {Colors.map((category) => (
            <a alt={category.alt} href={category.link} target="_blank">
              <div className="relative font-medium flex items-center content-center">
                <div className="w-full px-3 py-3">
                  <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="md:flex">
                      <div className="md:flex-shrink-0 hidden sm:block">
                        <img
                          className="h-24 w-full object-cover md:h-full md:w-48"
                          src={category.img}
                          alt="Man looking at item at a store"
                        />
                      </div>
                      <div className="p-8">
                        <h2
                          href="#"
                          className="block mt-1 text-lg leading-tight font-medium text-black hover:underline"
                        >
                          {category.title}
                        </h2>
                        <p className="mt-2 text-gray-500">
                          {category.description}
                        </p>
                        <div className="flex flex-row mt-4">
                          {category.tags.map((tag) => (
                            <div className="px-2 py-1 rounded-xl bg-slate-100 text-text-primary text-xs w-fit mr-3">
                              {tag}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
          <h3 className="text-blue-700 ml-3 mt-6">Illustrations</h3>
          {Illustrations.map((category) => (
            <a alt={category.alt} href={category.link} target="_blank" rel="noreferrer">
              <div className="relative font-medium flex items-center content-center">
                <div className="w-full px-3 py-3">
                  <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="md:flex">
                      <div className="md:flex-shrink-0 hidden sm:block">
                        <img
                          className="h-24 w-full object-cover md:h-full md:w-48"
                          src={category.img}
                          alt="Man looking at item at a store"
                        />
                      </div>
                      <div className="p-8">
                        <h2
                          href="#"
                          className="block mt-1 text-lg leading-tight font-medium text-black hover:underline"
                        >
                          {category.title}
                        </h2>
                        <p className="mt-2 text-gray-500">
                          {category.description}
                        </p>
                        <div className="flex flex-row mt-4">
                          {category.tags.map((tag) => (
                            <div className="px-2 py-1 rounded-xl bg-slate-100 text-text-primary text-xs w-fit mr-3">
                              {tag}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </AccordionPanel>
        <AccordionItem
          toggle="panel-2"
          className="bg-indigo-200 text-text-primary rounded-lg text-xl font-medium"
        >
          Outils développement web
        </AccordionItem>
        <AccordionPanel id="panel-2">
        <h3 className="text-blue-700 ml-3">Outils</h3>
          {DevTools.map((category) => (
            <a alt={category.alt} href={category.link} target="_blank">
              <div className="relative font-medium flex items-center content-center">
                <div className="w-full px-3 py-3">
                  <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="md:flex">
                      <div className="md:flex-shrink-0 hidden sm:block">
                        <img
                          className="h-24 w-full object-cover md:h-full md:w-48"
                          src={category.img}
                          alt="Man looking at item at a store"
                        />
                      </div>
                      <div className="p-8">
                        <h2
                          href="#"
                          className="block mt-1 text-lg leading-tight font-medium text-black hover:underline"
                        >
                          {category.title}
                        </h2>
                        <p className="mt-2 text-gray-500">
                          {category.description}
                        </p>
                        <div className="flex flex-row mt-4">
                          {category.tags.map((tag) => (
                            <div className="px-2 py-1 rounded-xl bg-slate-100 text-text-primary text-xs w-fit mr-3">
                              {tag}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
           <h3 className="text-blue-700 ml-3">Bacs à sable</h3>
          {SandBox.map((category) => (
            <a alt={category.alt} href={category.link} target="_blank">
              <div className="relative font-medium flex items-center content-center">
                <div className="w-full px-3 py-3">
                  <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="md:flex">
                      <div className="md:flex-shrink-0 hidden sm:block">
                        <img
                          className="h-24 w-full object-cover md:h-full md:w-48"
                          src={category.img}
                          alt="Man looking at item at a store"
                        />
                      </div>
                      <div className="p-8">
                        <h2
                          href="#"
                          className="block mt-1 text-lg leading-tight font-medium text-black hover:underline"
                        >
                          {category.title}
                        </h2>
                        <p className="mt-2 text-gray-500">
                          {category.description}
                        </p>
                        <div className="flex flex-row mt-4">
                          {category.tags.map((tag) => (
                            <div className="px-2 py-1 rounded-xl bg-slate-100 text-text-primary text-xs w-fit mr-3">
                              {tag}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </AccordionPanel>
        <AccordionItem
          toggle="panel-3"
          className="bg-indigo-300 text-text-primary rounded-lg text-xl font-medium"
        >
          Apprentissage
        </AccordionItem>
        <AccordionPanel id="panel-3">
          {Learning.map((category) => (
            <a href={category.link} target="_blank">
              <div className="relative font-medium flex items-center content-center">
                <div className="w-full px-3 py-3">
                  <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="md:flex">
                      <div className="md:flex-shrink-0 hidden sm:block">
                        <img
                          className="h-24 w-full object-cover md:h-full md:w-48"
                          src={category.img}
                          alt="Man looking at item at a store"
                        />
                      </div>
                      <div className="p-8">
                        <h2
                          href="#"
                          className="block mt-1 text-lg leading-tight font-medium text-black hover:underline"
                        >
                          {category.title}
                        </h2>
                        <p className="mt-2 text-gray-500">
                          {category.description}
                        </p>
                        <div className="flex flex-row mt-4">
                          {category.tags.map((tag) => (
                            <div className="px-2 py-1 rounded-xl bg-slate-100 text-text-primary text-xs w-fit mr-3">
                              {tag}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </AccordionPanel>
        <AccordionItem
          toggle="panel-4"
          className="bg-indigo-400 text-text-primary rounded-lg text-xl font-medium" 
        >
          Design UX / UI 
        </AccordionItem>
        <AccordionPanel id="panel-4">
          {Design.map((category) => ( 
            <a href={category.link} target="_blank">
              <div className="relative font-medium flex items-center content-center">
                <div className="w-full px-3 py-3">
                  <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="md:flex">
                      <div className="md:flex-shrink-0 hidden sm:block">
                        <img
                          className="h-24 w-full object-cover md:h-full md:w-48"
                          src={category.img}
                          alt="Man looking at item at a store"
                        />
                      </div>
                      <div className="p-8">
                        <h2
                          href="#"
                          className="block mt-1 text-lg leading-tight font-medium text-black hover:underline"
                        >
                          {category.title}
                        </h2>
                        <p className="mt-2 text-gray-500">
                          {category.description}
                        </p>
                        <div className="flex flex-row mt-4">
                          {category.tags.map((tag) => (
                            <div className="px-2 py-1 rounded-xl bg-slate-100 text-text-primary text-xs w-fit mr-3">
                              {tag}
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </a>
          ))}
        </AccordionPanel>
      </Accordion>
    </Layout>
  );
};

export default ResourcePage;
